(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Bank Info Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, $rootScope, $stateParams, UserSession) {
    // console.log("Bank Info Controller Func: ", $scope);
    $scope.wcmContent = wcmContent;
    $scope.editMode = $scope.card && $scope.card.paymentMethodId ? true : false;
    $scope.showMaskingButtons = true;
    //$scope.showmask = false;
    $scope.maskedAccountTxt = "This is the 3-16 digit number located to the right of the routing number on your checks. For your security this number won't autofill, and will be masked after entry. Contact your bank for any assistance."  
    if($scope.editMode){
      $scope.firstName = $scope.card.cardholder.firstName;
      $scope.lastName = $scope.card.cardholder.lastName;
      $scope.accountNumber = $scope.card.accountNumber;
      $scope.routingNumber = $scope.card.routingNumber;
      if($scope.card.relationshipToCardHolder === 'SELF'){
        $scope.relationshipToCardHolder = $scope.card.relationshipToCardHolder + ' (PATIENT)';
       } else {
        $scope.relationshipToCardHolder = $scope.card.relationshipToCardHolder;
      }

    };
    if($scope.$parent.editFromAutoPayments){
      if($scope.$parent.editFromAutoPayments && localStorage.getItem("transactionMode") === 'ADD' || localStorage.getItem("transactionMode") === ''){
        $scope.editMode = false;
      } else {
        $scope.editMode = true;
      }
    }

    // GST-2055 Add a bank account page on click of back button link bank account number should masked on page load

    if ($scope.accountNumber && localStorage.getItem("transactionMode") === 'EDIT') {
      $scope.editFromMOPBankAccount = true;
    }

    if (localStorage.getItem("transactionMode") === 'ADD') {
      $scope.addFromNewBankAccount = true;
    }

    // GST-54 Mask Bank Account Number on "Edit bank account" screen after adding a bank account number
    if ($rootScope.accountNumber && localStorage.getItem("transactionMode") === 'ADD') {
      var orig = $rootScope.accountNumber;
      $scope.mask = {
        accountNumber: orig.replace(/\d/g, 'X')
      };
      $scope.showmask = true;
    }
    
    /* 
     * START: GST-35 PCI Issue: UI: Mask bank account number on the add a bank account flow
     * GST-54 PCI Issue: UI: Mask Bank Account Number on "Edit bank account" screen after adding a bank account number
     */
    $scope.maskClick = function (ev) {
      if ($scope.enableKeydownMask) {
        //select
        ev.currentTarget.select();
      } else {
        $scope.showAccountNumber();
      }
    }

    $scope.maskKeydown = function (ev) {

      if(ev.keyCode === 16 && ev.shiftKey) {
        return;
      }
      if(ev.keyCode === 9) {
        // if tab key is pressed, prevent focus ofinput
        if($scope.accountNumber === '') {
          $scope.showMask = false;
        }
        return;
      }

      //if($scope.enableKeydownMask) {
      if (ev.keyCode >= 48 && ev.keyCode <= 57) {
         //0 and 9
         $scope.accountNumber += String.fromCharCode(ev.keyCode);
        $("#ccShowBlock input").val($scope.accountNumber);
      } else {
        $("#ccShowBlock input").val('');
        //$scope.$parent.cardInfoForm.cardAccountNum.$viewValue = '';
        $scope.accountNumber = '';
        $("#ccShowBlock input").val('');
      }
      $rootScope.$broadcast('setCardAccountNumOnAdd', {
        cardAccountNum: $scope.accountNumber
      });
      $scope.showMask = false;

      setTimeout(function () {
        $("#ccShowBlock input").focus();
      }, 100);
      // }
    }

    /*  @author viswa- z241843
     *  This function will mask the account number and it will send the account value on form submit   
     */

    $scope.maskAccountNumber = function maskAccountNumber() {
      if ($scope.$parent.hasOwnProperty('bankInfoForm') && $scope.$parent.bankInfoForm.cardaccount.$viewValue != '') {
        $rootScope.accountNumber = $scope.$parent.bankInfoForm.cardaccount.$viewValue;
        var orig = $rootScope.accountNumber;
        $scope.mask = { accountNumber: orig ? orig.replace(/\d/g, 'X'): '' };
        $rootScope.$broadcast('setBankAccountNumber', { bankAccountNum: $rootScope.accountNumber });
        $scope.showmask = true;
      }
      if ($rootScope.accountNumber === '' || ($scope.mask && $scope.mask.accountNumber === '')) {
        $scope.mask = { accountNumber: "" };
        $scope.showmask = false;
      }
    };
    
    $scope.onShowAccountNumberKeyDown = function (ev) {
      if(ev.keyCode === 9 && !ev.shiftKey) {
        // if tab is pressed
        setTimeout(function () {
          $("#ccShowBlock #show-ba").focus();
        }, 100);
      }
  }

  
    $scope.showAccountNumber = function () {
      $scope.showmask = false;
      setTimeout(function () {
        $("#ccShowBlock input").focus();
      }, 100);
    };

    if ($scope.card.transactionMode === 'ADD' && $stateParams.editMode) {
      $scope.showMaskingButtons = true;
      $scope.showmask = true;
      if ($scope.$parent.hasOwnProperty('bankInfoForm') && $rootScope.accountNumber != '') {
        $rootScope.$broadcast('setBankAccountNumber', { bankAccountNum: $rootScope.accountNumber });
      }
    }

    /* 
     * END: GST-35 & GST-54 
     */

    // TODO: Probably good idea to move these to a global utility
    $scope.confirmLength = function(value, length) {
      if (!value) return false;
      $scope.validLength =  ("" + value).length !== length;
    };

    $scope.confirmRange = function(value, min, max) {
      if (!value) return false;
      $scope.validRange =  ("" + value).length < min || ("" + value).length > max;
    };
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/bankInfo/bankInfo.template.html',
      controller: controllerFunction,
      link: linkFunction,
      scope:{
        card:"="
      }
    }
  }

  controllerFunction.$inject = ["$scope", "$rootScope", "$stateParams", "userSession"];
  angular.module('cvsApp').directive('bankInfo', directiveFunction);

})();
